export const InfoIcons = (props) => (
  <svg fill="none" height={16} viewBox="0 0 16 16" width={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.9987 14.6667C11.6806 14.6667 14.6654 11.6819 14.6654 8.00001C14.6654 4.31811 11.6806 1.33334 7.9987 1.33334C4.3168 1.33334 1.33203 4.31811 1.33203 8.00001C1.33203 11.6819 4.3168 14.6667 7.9987 14.6667Z"
      stroke="#667085"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M8 10.6667V7.66666" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 5.34114V5.33447" stroke="#667085" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} />
  </svg>
);
